import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery } from '@apollo/client/react';
import { Button, ButtonProps, Heading, Icon, Text, useDisclosure, Dialog } from '@chakra-ui/react';
import { paywallPropsForMessagingTarget } from '@src/components/sco/Chat/directMessagePaywall';
import { useMatchingContext } from '@src/components/sco/Matching/Layout/MatchingContext';
import { UserMatchIntroModal } from '@src/components/sco/Matching/UserMatchIntroModal';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import React, { useState } from 'react';
import { FaMessage } from 'react-icons/fa6';
export const UserMatchSendMessageButton = props => {
  const $ = _c(42);
  const matchingContext = useMatchingContext();
  const {
    currentUser
  } = useCurrentUser();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showMaxModal, setShowMaxModal] = useState(false);
  const {
    open,
    onOpen,
    onClose
  } = useDisclosure();
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($userMatchId: String!) {
        scoUserMatch(userMatchId: $userMatchId) {
          id
          userMatchId
          targetUserId
          targetUser {
            id
            userId
            isAdvisor
            isToolUser
            slug
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !props.userMatchId;
  let t2;
  if ($[1] !== props.userMatchId) {
    t2 = {
      userMatchId: props.userMatchId
    };
    $[1] = props.userMatchId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      ssr: false,
      skip: t1,
      variables: t2
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const query = useQuery(t0, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = gql`
    mutation ($input: UpsertDirectChatThreadInput!) {
      upsertDirectChatThread(input: $input) {
        thread {
          id
          threadId
          commentsAndRepliesCount
        }
        viewer {
          id
          currentUser {
            id
            remainingMemberChatsCount
          }
        }
      }
    }
  `;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const [upsertDirectChatThread] = useMutation(t4);
  const t5 = query.data?.scoUserMatch?.targetUser;
  let t6;
  if ($[7] !== currentUser || $[8] !== t5) {
    t6 = paywallPropsForMessagingTarget(t5, currentUser);
    $[7] = currentUser;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const teamPaywall = t6;
  let t7;
  if ($[10] !== currentUser || $[11] !== matchingContext || $[12] !== onOpen || $[13] !== query.data || $[14] !== teamPaywall || $[15] !== upsertDirectChatThread) {
    t7 = async () => {
      if (teamPaywall && !teamPaywall.isUnlocked) {
        return;
      }
      setError(null);
      setIsLoading(true);
      if (query.data?.scoUserMatch?.userMatchId) {
        if (currentUser.remainingMemberChatsCount <= 0) {
          setIsLoading(false);
          setShowMaxModal(true);
          return;
        }
        const threadResult = await upsertDirectChatThread({
          variables: {
            input: {
              memberUserIds: [currentUser?.userId, query.data.scoUserMatch.targetUserId]
            }
          }
        });
        const thread = threadResult.data?.upsertDirectChatThread?.thread;
        if (thread?.threadId) {
          if (thread.commentsAndRepliesCount > 0) {
            matchingContext.setChatThreadId(thread.threadId);
          } else {
            onOpen();
          }
        } else {
          matchingContext.setChatThreadId(null);
          setError("Failed to create chat thread.");
        }
      } else {
        setError("Invalid UserMatch record.");
      }
      setIsLoading(false);
    };
    $[10] = currentUser;
    $[11] = matchingContext;
    $[12] = onOpen;
    $[13] = query.data;
    $[14] = teamPaywall;
    $[15] = upsertDirectChatThread;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const onSendMessageClick = t7;
  if (error) {
    let t8;
    if ($[17] !== error) {
      t8 = <Button colorPalette="red" size="sm">Error: ${error}</Button>;
      $[17] = error;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    return t8;
  }
  let t8;
  if ($[19] !== getBreakpointValue) {
    t8 = getBreakpointValue(["xs", "xs", "sm"]);
    $[19] = getBreakpointValue;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Icon asChild={true}><FaMessage /></Icon>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== isLoading || $[23] !== onSendMessageClick || $[24] !== props.buttonProps || $[25] !== t8) {
    t10 = <Button disabled={isLoading} loading={isLoading} size={t8} variant="cta" onClick={onSendMessageClick} {...props.buttonProps}>{t9}Send Message</Button>;
    $[22] = isLoading;
    $[23] = onSendMessageClick;
    $[24] = props.buttonProps;
    $[25] = t8;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const sendButton = t10;
  let t11;
  if ($[27] !== props.buttonProps || $[28] !== sendButton || $[29] !== teamPaywall) {
    t11 = teamPaywall && !teamPaywall.isUnlocked ? <PaywalledAction contentPermission={teamPaywall.contentPermission} isUnlocked={teamPaywall.isUnlocked} upgradeCtaButtonProps={props.buttonProps} upgradeCtaLabel="Upgrade to Message" upgradeProductId={teamPaywall.upgradeProductId} variant="button-only">{sendButton}</PaywalledAction> : sendButton;
    $[27] = props.buttonProps;
    $[28] = sendButton;
    $[29] = teamPaywall;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = matchingContext.activeUserMatchId || props.userMatchId;
  let t13;
  if ($[31] !== onClose || $[32] !== open || $[33] !== t12) {
    t13 = <UserMatchIntroModal open={open} userMatchId={t12} onClose={onClose} />;
    $[31] = onClose;
    $[32] = open;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setShowMaxModal(false);
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== showMaxModal) {
    t15 = <MaxIntroSentModal open={showMaxModal} onClose={t14} />;
    $[36] = showMaxModal;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t11 || $[39] !== t13 || $[40] !== t15) {
    t16 = <>{t11}{t13}{t15}</>;
    $[38] = t11;
    $[39] = t13;
    $[40] = t15;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  return t16;
};
export const MaxIntroSentModal = props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = t1 => {
      const {
        open
      } = t1;
      if (!open) {
        props.onClose();
      }
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Dialog.Backdrop />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Dialog.CloseTrigger />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Heading>You've sent 10 intros today.</Heading>;
    t4 = <Text marginBottom="1em">You'll be able to send more introductions tomorrow.</Text>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.onClose) {
    t5 = <Dialog.Positioner><Dialog.Content bgColor="colorPalette.container">{t2}<Dialog.Body paddingX={8} paddingY={12} textAlign="center">{t3}{t4}<Button width="full" onClick={props.onClose}>Close</Button></Dialog.Body></Dialog.Content></Dialog.Positioner>;
    $[6] = props.onClose;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.open || $[9] !== t0 || $[10] !== t5) {
    t6 = <Dialog.Root open={props.open} onOpenChange={t0}>{t1}{t5}</Dialog.Root>;
    $[8] = props.open;
    $[9] = t0;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};